import React, { ReactElement } from 'react';

export default function Conference(): ReactElement {
  return (
    <div className="header-bar">
      <h1>Conference Call</h1>
    </div>
  )
}
